// extracted by mini-css-extract-plugin
module.exports = {"base":"CareerLogo-module-base","sublineContainer":"CareerLogo-module-subline-container","subline":"CareerLogo-module-subline","icon":"CareerLogo-module-icon"};